<script setup lang="ts">
import type { PhotoDTO } from '~/shared/api/client/photo/photo.dto';
import { resizeImageAttrs } from '~/shared/lib/resizeImage';

const props = defineProps<{
  photo: PhotoDTO;
  title?: string;
}>();
const imageAttrs = computed(() =>
  resizeImageAttrs(props.photo.photo.file_url, { width: 320 }),
);
</script>

<template>
  <div :class="$style.item">
    <div :class="$style.item__imageLink">
      <img
        :src="imageAttrs.src"
        :srcset="imageAttrs.srcset"
        :alt="title"
        :class="$style.item__image"
      />
    </div>

    <div :class="$style.item__title">
      {{ title }}
    </div>
  </div>
</template>

<style lang="scss" module>
.item {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--space-1-5x);

  &__title {
    display: block;
    @include text_body2;
    color: var(--color-black-1);
    text-decoration: none;
  }

  &__image {
    max-width: 100%;
    height: auto;
    display: block;
  }
}

@media (hover: hover) {
  .item {
    transition: all 0.2s;

    &:hover {
      opacity: 0.85;
    }
  }
}

@media (min-width: 480px) and (max-width: 767px) {
  .item {
    &__image {
      width: 100%;
    }
  }
}
</style>
